// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"loadingIndicator-_hnaE","rotate":"rotate-pAy2_"};